import * as React from "react";
const SvgFiRrLeadershipAlt = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#fi-rr-leadership-alt_svg__a)">
      <path
        fill="#062147"
        d="M4 19a2.5 2.5 0 0 1-2.5-2.5C1.5 15.121 2.621 14 4 14s2.5 1.121 2.5 2.5S5.38 19 4 19m10.5-2.5a2.5 2.5 0 1 0-4.999 0 2.5 2.5 0 0 0 5 0M12 5a2.5 2.5 0 1 0 .001-5 2.5 2.5 0 0 0 0 5m5.5 11.5a2.5 2.5 0 1 0 5 0 2.5 2.5 0 0 0-5 0m.336-9.186 5.315-4.556a1 1 0 0 0 .108-1.409.997.997 0 0 0-1.41-.108l-5.314 4.555A5 5 0 0 1 13.281 7h-2.56a5 5 0 0 1-3.255-1.203L2.151 1.241A1 1 0 0 0 .85 2.758l5.315 4.557A7 7 0 0 0 8 8.426v4.073a1 1 0 1 0 2 0V8.935c.24.025.477.064.72.064h2.561c.243 0 .48-.039.72-.064v3.564a1 1 0 1 0 2 0V8.426a7 7 0 0 0 1.836-1.112m6.1 15.331c-.6-1.582-2.182-2.646-3.936-2.646s-3.335 1.063-3.935 2.646a1 1 0 1 0 1.871.709c.307-.811 1.137-1.354 2.065-1.354s1.758.544 2.065 1.354a1 1 0 0 0 1.29.582c.515-.196.775-.773.58-1.29zM12 19.999c-1.754 0-3.335 1.063-3.935 2.646a1 1 0 1 0 1.871.709c.307-.811 1.137-1.354 2.065-1.354s1.758.544 2.065 1.354a1 1 0 0 0 1.29.582c.515-.196.775-.773.58-1.29-.6-1.582-2.18-2.646-3.935-2.646zm-8 0c-1.754 0-3.335 1.063-3.935 2.646a1 1 0 1 0 1.871.709C2.243 22.543 3.073 22 4.001 22s1.758.544 2.065 1.354a1 1 0 0 0 1.29.582c.515-.196.775-.773.58-1.29C7.336 21.064 5.756 20 4.001 20z"
      />
    </g>
    <defs>
      <clipPath id="fi-rr-leadership-alt_svg__a">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgFiRrLeadershipAlt;
